import { gql } from "@apollo/client";
export const LOCKER_USER_ACCOUNTS_FOR_VIEW_PACKAGE_HISTORY = gql`
  query ($operatorId: ID!, $userMobile: String) {
    lockerUserAccounts(operatorId: $operatorId, userMobile: $userMobile) {
      user {
        firstName
        middleName
        lastName
        suffixName
        userMobile
        userEmail
        userId
      }
      userAccountId
    }
  }
`;
export const LOCKER_NAME_FOR_VIEW_PACKAGE_HISTORY = gql`
  query ($operatorId: ID!) {
    lockers(operatorId: $operatorId) {
      lockerName
      lockerId
    }
  }
`;
export const FILTER_PACKAGES = gql`
  query (
    $operatorId: ID!
    $startDate: Date
    $endDate: Date
    $packageId: ID
    $recipientMobile: String
    $waybillNumber: String
    $lockerId: [ID]
    $services: Int
    $doorId: String
    $packageStorageId: String
  ) {
    filterPackages(
      operatorId: $operatorId
      startDate: $startDate
      endDate: $endDate
      packageId: $packageId
      recipientMobile: $recipientMobile
      waybillNumber: $waybillNumber
      lockerId: $lockerId
      services: $services
      doorId: $doorId
      packageStorageId: $packageStorageId
    ) {
      userAccount {
        userAccountId
        user {
          userId
        }
      }
      packageId
      transactionId
      partnerAgentMobile
      senderMobile
      recipientMobile
      packageDate
      waybillNumber
      partnerAgentId
      statusDate
      packageStateNo
      pickupByDate
      senderName
      lockerLocation
      door {
        doorNumber
        doorAddress
      }
      locker {
        lockerId
        lockerName
      }
      packageDetected
      partnerBusinessPartnerId
      partnerName
    }
  }
`;

export const NEW_PACKAGE_HISTORY_QUERY_WITH_PAYMENT = gql`
  query (
    $waybillNumber: String
    $operatorId: ID!
    $startDate: Date
    $endDate: Date
    $packageId: ID
    $recipientMobile: String
    $doorId: String
    $services: Int
    $lockerId: ID
    $packageStorageId: String
  ) {
    getPackageDetails(
      waybillNumber: $waybillNumber
      operatorId: $operatorId
      startDate: $startDate
      endDate: $endDate
      packageId: $packageId
      recipientMobile: $recipientMobile
      doorId: $doorId
      services: $services
      lockerId: $lockerId
      packageStorageId: $packageStorageId
    ) {
      package {
        userAccount {
          userAccountId
          user {
            userId
            __typename
          }
          __typename
        }
        packageId
        transactionId
        partnerAgentMobile
        senderMobile
        recipientMobile
        waybillNumber
        partnerAgentId
        packageStateNo
        senderName
        packageDate
        statusDate
        pickupByDate
        takebackOn
        pulloutOn
        lockerLocation
        door {
          doorNumber
          doorAddress
          __typename
        }
        locker {
          lockerId
          lockerName
          __typename
        }
        packageDetected
        __typename
      }
      partnerBusinessPartnerId
      partnerName
      payments {
        paymentId
        orderId
        paymentDate
        paymentAmount
        paymentCurrency
        paymentStatus
        duplicate
        __typename
      }
      __typename
    }
  }
`;
